import { Actions } from "../Actions/Actions";

const initialState = {
  isSideBarOpen: false,
  game: null,
  gameId: 64,
  leagueList: [],
};

export default function sidebarReducer(state = initialState, action) {
  switch (action.type) {
    case Actions.SIDEBAR_EXPAND:
      return {
        ...state,
        isSideBarOpen: action.data,
      };
    case Actions.LEAGUE_GAMES:
      return {
        ...state,
        leagueList: action.data,
      };
    case Actions.SET_GAME:
      return {
        ...state,
        game: action.data,
        gameId: action.Id,
      };
    case Actions.CLEAR_GAME:
      return {
        ...state,
        game: null,
        gameId: 64,
      };
    default:
      return state;
  }
}
